import React from "react";
const TeamsText = () => {
  return (
    <div>
      <h1>Lagen</h1>
      <h2>Djurgårdens lag säsongen 2025/2026</h2>

      <h3>Damer:</h3>
      <p>A-laget spelar i div 1.</p>
      <p>B-laget spelar i div 1.</p>
      <p>C-laget spelar i div 2.</p>
      <p>D-laget spelar i div 3.</p>
      <p>E-laget spelar i div 3.</p>
      <p>F-laget spelar i div 3.</p>

      <h3>Herrar:</h3>
      <p>A-laget spelar i div 4.</p>
      <p>B-laget spelar i div 6.</p>
      <p>C-laget spelar i div 7.</p>
      <p>D-laget spelar i div 7.</p>
      <p>E-laget spelar i div 7.</p>
      <p>F-laget spelar i div 7.</p>
      <p>G-laget spelar i div 8.</p>

      <h3>Pensionärer:</h3>
      <p>A-laget spelar i Serie D.</p>

      <h3>Veteraner:</h3>
      <p>A-laget spelar i div 3.</p>
      <p>B-laget spelar i div 3.</p>

      <p>
        För kontakt med respektive lagledare mejla till{" "}
        <a href="mailto: difbtx@gmail.com">difbtx@gmail.com</a>
      </p>
    </div>
  );
};

export default TeamsText;
